export const trimAll = (text) => text.replace(/\s/g, '');

export default {
  trimAll,
};
